import React from 'react'
import './TimePicker.css'

function TimePicker({ id, name, onChange, onBlur, value }) {
    return (
        <input
            className="timePicker"
            id={id}
            name={name}
            onChange={onChange}
            onBlur={onBlur}
            type="time"
            value={value}
        />
    )
}

export default TimePicker
